(function () {
	function swiperInit() {
		if (typeof subSliderInit === 'function') subSliderInit(true);
		if (typeof sliderInit === 'function') sliderInit(true);
		if (typeof updatethumbnail === 'function') updatethumbnail(true);
		
	}

	document.addEventListener("shopify:section:load", function () {
		swiperInit();
	});

	document.addEventListener("resize", function () {
		swiperInit();
	});

	document.addEventListener("visibilitychange", function () {
		swiperInit();
	});

	swiperInit();
})();
